import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { string, bool } from 'prop-types';
import SsrScript from '../SsrScript/index.jsx';

/**
 * FontManager component.
 */
var _ref = /*#__PURE__*/React.createElement("html", {
  lang: "en",
  className: "wf-active"
});
const FontManager = ({
  adobeFontsId,
  cssEmbed
}) => {
  const [currentId, setCurrentId] = useState();

  // Clean up any previous scripts if the ID changes, or on unmount
  useEffect(() => {
    const clean = () => {
      [...document.querySelectorAll('script[src^="https://use.typekit.net"]')].forEach(el => {
        el.parentNode.removeChild(el);
      });
    };
    if (currentId) {
      clean();
    }
    setCurrentId(adobeFontsId);
    return () => {
      clean();
    };
  }, [adobeFontsId]);
  if (!adobeFontsId) {
    return null;
  }
  if (cssEmbed) {
    return /*#__PURE__*/React.createElement(Helmet, null, _ref, /*#__PURE__*/React.createElement("link", {
      rel: "stylesheet",
      href: `https://use.typekit.net/${adobeFontsId}.css`
    }));
  }

  // Use the Adobe Fonts JavaScript embed code to load
  // https://helpx.adobe.com/fonts/using/embed-codes.html#JavaScriptembedcode
  return /*#__PURE__*/React.createElement(SsrScript, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", null, `
            (function(d) {
              var config = {
                kitId: '${adobeFontsId}',
                scriptTimeout: 3000,
                async: true
              },
              h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
            })(document);
          `)));
};
FontManager.defaultProps = {
  adobeFontsId: null,
  cssEmbed: false
};
FontManager.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An Adobe Fonts ID. */
  adobeFontsId: string,
  /** True if Font Manager should be loaded via css. */
  cssEmbed: bool
} : {};
export default FontManager;